import { paths } from "helpers/paths";
import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import * as source from "sources/books/classificationTypes";
import connect from "./container";
import Form from "./form";
import List from "./list";

function ClassificationTypes(props) {
    useEffect(() => {
        return () => props.clearParams("classification-types");
    }, []);

    const { location, history } = props;
    const back = () => history.push(paths.classificationTypes);
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route
                    exact
                    path={paths.classificationTypesNew}
                    render={() => (
                        <Form
                            {...props}
                            transition="full"
                            title="Добавить тип номенклатуры"
                            back={back}
                            source={source}
                        />
                    )}
                />
                <Route
                    path={paths.classificationTypesShow(":id")}
                    render={(rest) => (
                        <Form {...rest} transition="full" title="Тип номенклатуры" back={back} source={source} />
                    )}
                />
                <Route
                    exact
                    path={paths.classificationTypes}
                    render={() => (
                        <List
                            {...props}
                            isTable
                            transition="full"
                            title="Типы номенклатур"
                            nofilter
                            createBtnText="Добавить тип номенклатуры"
                            back={() => history.push(paths.root)}
                        />
                    )}
                />
            </Switch>
        </div>
    );
}

export default connect(ClassificationTypes);
